import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import { FiltroPeriodosMora, PeriodoMora } from "../modelo/AdminPeriodosMora";
import { consultarPeriodos, descargarXLSPeriodosMora } from "../modulos/periodosMoraActions";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import "react-month-picker/css/month-picker.css";
import TablaPeriodosMora from "./TablaPeriodosMora";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { consecutivoNIT, documentoEmpleador, poliza, tipoDocumentoEmpleador } from "../../config_general/modelo/TextosAyuda";

class PeriodosMora extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {};
    }

    render() {
        const { periodos, estado, paginas, tamanoPagina, paginaActual, totalPeriodosConsulta } = this.props;

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Periodos En Mora</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta de periodos en mora</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="numeroPoliza">Póliza</label>
                                                <TextoAyuda texto={poliza} />
                                                <NumericInput name="numeroPoliza" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={2}>
                                                <label htmlFor="consecutivoNIT">Consecutivo NIT</label>
                                                <TextoAyuda texto={consecutivoNIT} />
                                                <NumericInput name="consecutivoNIT" />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {!(submitting || invalid) &&
                                                        <a className="btns btn-success" onClick={() => this.descargarXLSPeriodosMora(values)}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderTablaAdminGlosas(periodos, estado, paginas, tamanoPagina, paginaActual, totalPeriodosConsulta)}
                </Row>
            </div>
        );
    }

    renderTablaAdminGlosas(periodos: Array<PeriodoMora>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number, totalPeriodosConsulta: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!periodos || !periodos.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado periodos en mora"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaPeriodosMora
                                periodos={periodos}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    filtros(): FiltroPeriodosMora {
        return {
            numeroPoliza: this.state.numeroPoliza,
            tipoDocumento: this.state.tipoDocumento,
            documento: this.state.documento,
            consecutivoNIT: this.state.consecutivoNIT
        };
    }

    consultaPaginada = (filtro: FiltroPeriodosMora) => {
        this.props.dispatch(consultarPeriodos(filtro));
    };

    descargarXLSPeriodosMora = (values: any) => {
        const filtro = this.obtenerValores(values);
        this.props.dispatch(descargarXLSPeriodosMora(filtro));
    }

    onSubmit = (values: any) => {
        this.props.dispatch(consultarPeriodos(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {
        const numeroPoliza = values.numeroPoliza ? values.numeroPoliza.valueOf() : undefined;
        const tipoDocumento = values.tipoDocumento ? values.tipoDocumento.valueOf() : undefined;
        const documento = values.documento ? values.documento.valueOf() : undefined;
        const consecutivoNIT = values.consecutivoNIT ? values.consecutivoNIT.valueOf() : undefined;

        const filtro: FiltroPeriodosMora = {
            numeroPoliza: numeroPoliza,
            tipoDocumento: tipoDocumento,
            documento: documento,
            consecutivoNIT: consecutivoNIT,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            numeroPoliza: numeroPoliza,
            tipoDocumento: tipoDocumento,
            documento: documento,
            consecutivoNIT: consecutivoNIT,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            numeroPoliza: undefined,
            tipoDocumento: undefined,
            documento: undefined
        };

        if (!values.numeroPoliza && !values.tipoDocumento)
            errors.numeroPoliza = "Por favor ingrese un numero de póliza";

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Por favor ingrese un documento";

        return errors;
    };
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estado: R.pathOr([], ["periodos_mora", "estado"])(store),
        periodos: R.pathOr([], ["periodos_mora", "periodos"])(store),
        paginas: R.pathOr([], ["periodos_mora", "paginas"])(store),
        paginaActual: R.pathOr([], ["periodos_mora", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["periodos_mora", "tamanoPagina"])(store),
        totalPeriodosConsulta: R.pathOr([], ["periodos_mora", "totalPeriodosConsulta"])(store)
    };
})(PeriodosMora);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/periodos_mora/componentes/PeriodosMora.tsx